<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MepQI7/tc-custom/9781681886695.jpg?1705147891733" alt="This image is the cover for the book Fishing Guide, Field & Stream"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fishing Guide, Field & Stream
      </h1>
      <p class="bookDescription body article font2">
        <b>Catch all of the fishing information from <i>The Total Outdoorsman Manual</i> in one value-priced edition—from one of the most trusted outdoor sports brands. </b><br/><br/>With practical advice for fly-fishing, baitcasting, spinning and even noodling, this handy guide offers over one hundred hints on gear, knots, boating, and finding where even the stealthiest fish are hiding. Fishers from the dedicated weekend angler to summer dabblers rely on <i>Field &amp; Stream</i> for the best insider information, and this book delivers.<br/><br/>In this guide, you’ll learn how to:Harvest nature’s bait shopFly cast upside-downScale a fish with bottle capsMake fish fried riceSet any anchor, anytimeWin the toughest fish fightTake a jaw-dropping fish photoAnd much more
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        T. Edward Nickens, The Editors of Field & Stream
      </h2>
      
      <p class="authorDescription body article">Field & Stream editor-at-large T. Edward Nickens has fished, paddled, backpacked, hunted, and camped from the rainforest to the Arctic Sea. Winner of more than two dozen national writing awards, he is TV host for the Total Outdoorsman Challenge.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Weldon Owen
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?598de5d8